<div *ngIf="dashboard">
  <div *ngFor="let slider of benefit; let i = index" class="slider-container-desktop mb-4" [ngClass]="shouldApplyBackgroundClass(slider.benefits) ? 'background-slider' : ''">
    <div class="container-desktop">
      <img
        *ngIf="!slider.title && slider.imageTitle"
        [src]="slider.imageTitle"
        alt="Title Image"
        class="title-image"
      />
      <div class="title-overlay">
        <h3 [ngClass]="slider.order === '1' ? 'title-2' : 'title'" *ngIf="slider.title !== 'null' && !customTitle">{{ slider.title }}</h3>
        <h3 *ngIf="customTitle" class="custom-title">{{ customTitle }}</h3>
        <a
          *ngIf="!customTitle || slider.linkRedirect"
          [routerLink]="slider.linkRedirect"
          class="link"
        >
          {{ slider.linkText }}
        </a>
        <div class="see-all" *ngIf="seeAll">
          <a href="/beneficios-y-descuentos">
            Ver todos
          </a>
          <img src="../../../assets/icon/icon-see-all.svg" alt="">
        </div>
      </div>
    </div>    
    
    <div class="swiper-wrapper">
      <swiper #swiperDesktop class="swiper-desktop custom-width-swiper" [config]="getSliderConfig(slider.benefits)">
        <ng-template swiperSlide *ngFor="let item of slider.benefits">
            <app-benefit-box [item]="item.benefit" [bothTypes]="bothTypes"></app-benefit-box>
        </ng-template>
      </swiper>

      <div class="swiper-buttons-desktop">
        <div 
          (click)="slidePrev(i)" 
          class="swiper-button-prev hidden-xs left-desktop" 
          [hidden]="currentSlideIndex === 0"
        ></div>
        <div 
            *ngIf="isEnd === false"
            (click)="slideNext(i)" 
            class="swiper-button-next hidden-xs right-desktop" 
          ></div>
      </div>

    </div>
  </div>
</div>
<div *ngIf="!dashboard">
  <div *ngFor="let slider of benefit; let i = index" class="slider-container-desktop mb-4" [ngClass]="shouldApplyBackgroundClass(slider.benefits) ? 'background-slider' : ''">
    <div class="swiper-wrapper">
      <swiper #swiperDesktop class="swiper-desktop custom-width-swiper" [config]="getSliderConfig(slider.benefits)">
        <ng-template swiperSlide *ngFor="let item of slider.benefits">
          <app-benefit-box [item]="item.benefit" [bothTypes]="bothTypes"></app-benefit-box>
        </ng-template>
      </swiper>
      
      <div class="swiper-buttons-desktop">
        <div
          (click)="slideNext(i)"
          class="swiper-button-next hidden-xs right-desktop"
        ></div>
        <div
          (click)="slidePrev(i)"
          class="swiper-button-prev hidden-xs left-desktop"
        ></div>
      </div>
    </div>
  </div>
</div>

<div class="mobile" *ngIf="dashboard">
  <div class="swiper-benefits-mobile mb-4" *ngFor="let slider of benefit; let i = index" [ngClass]="shouldApplyBackgroundClass(slider.benefits) ? 'background-slider' : ''">
    <div class="container-mobile">
      <img
      *ngIf="!slider.title && slider.imageTitle"
      [src]="slider.imageTitle"
        alt="Title Image"
        class="title-image"
      />
      <div class="title-overlay">
        <h3 [ngClass]="slider.order === '1' ? 'title-2' : 'title'" *ngIf="slider.title !== 'null' && !customTitle">{{ slider.title }}</h3>
        <h3 *ngIf="customTitle" class="custom-title">{{ customTitle }}</h3>
        <a
          *ngIf="!customTitle || slider.linkRedirect"
          [routerLink]="slider.linkRedirect"
          class="link"
        >
          {{ slider.linkText }}
        </a>
        <div class="see-all" *ngIf="seeAll">
          <a href="/beneficios-y-descuentos">
            Ver todos
          </a>
          <img src="../../../assets/icon/icon-see-all.svg" alt="">
        </div>
      </div>
    </div>
  
    <div class="swiper-wrapper">
      <swiper #swiperMobile class="swiper-mobile" [config]="getSliderConfigMobile(slider.benefits)">
        <ng-template swiperSlide *ngFor="let item of slider.benefits">
          <app-benefit-box [item]="item.benefit" [bothTypes]="bothTypes"></app-benefit-box>
        </ng-template>
      </swiper>
    </div>
  </div>
</div>

<div class="mobile" *ngIf="!dashboard">
  <div class="swiper-benefits-mobile mb-4" *ngFor="let slider of benefit; let i = index" [ngClass]="shouldApplyBackgroundClass(slider.benefits) ? 'background-slider' : ''">  
    <div class="swiper-wrapper">
      <swiper #swiperMobile class="swiper-mobile" [config]="getSliderConfigMobile(slider.benefits)">
        <ng-template swiperSlide *ngFor="let item of slider.benefits">
          <app-benefit-box [item]="item.benefit" [bothTypes]="bothTypes"></app-benefit-box>
        </ng-template>
      </swiper>
    </div>
  </div>
</div>
